const { render } = wp.element; 
import App from './App';
import './style.css';

const pluginId = window.object.pluginId;

if (document.getElementById(pluginId)) { 
  const domElement = document.getElementById(pluginId);
  let attributes = domElement.getAttribute('attributes');
  try {
    attributes = JSON.parse(attributes);
  } catch (error) {
    console.warn('Invalid JSON for attributes:', attributes);
    attributes = {};
  }

  render(<App {...attributes} />, domElement);
}